import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["modal", "iframe"];

  connect() {
    document.addEventListener("keydown", this.handleEscKey.bind(this));
  }

  disconnect() {
    document.removeEventListener("keydown", this.handleEscKey.bind(this));
  }

  open() {
    this.modalTarget.classList.remove("hidden");
    document.body.classList.add("overflow-hidden");

    // Start playing video if there's an iframe
    if (this.hasIframeTarget) {
      const videoSrc = this.iframeTarget.getAttribute("data-src");
      this.iframeTarget.src = `${videoSrc}?autoplay=1&modestbranding=1&rel=0&showinfo=0&fs=1&iv_load_policy=3`;
    }
  }

  close() {
    this.modalTarget.classList.add("hidden");
    document.body.classList.remove("overflow-hidden");

    // Stop video playback
    if (this.hasIframeTarget) {
      this.iframeTarget.src = "";
    }
  }

  stopPropagation(event) {
    // Prevent clicks inside the video container from closing the modal
    event.stopPropagation();
  }

  handleEscKey(event) {
    if (
      event.key === "Escape" &&
      !this.modalTarget.classList.contains("hidden")
    ) {
      this.close();
    }
  }
}
